module.exports = __webpack_public_path__ + "img/warm_floor.f99f0753.svg";